var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDemoFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag_FILL0_wght300_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.5 20.75V4.5H13.5961L13.9961 6.5H19.5V15.5H13.4039L13.0039 13.5H6.99997V20.75H5.5ZM14.65 14H18V7.99998H12.75L12.35 5.99998H6.99997V12H14.25L14.65 14Z",
    fill: "#424242"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemoFlag);
export default __webpack_public_path__ + "static/media/demoFlag.429c8f99336f88e50cb595d2422e727b.svg";
export { ForwardRef as ReactComponent };